import { render, staticRenderFns } from "./StatsNombreArrives.vue?vue&type=template&id=519406a8&"
import script from "./StatsNombreArrives.vue?vue&type=script&lang=js&"
export * from "./StatsNombreArrives.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports